"use strict";

var processInclude = require("./util");

$(document).ready(function () {
    processInclude(require("./components/toggleCheckoutElements"));
    processInclude(require("./components/passwordValidation"));
    processInclude(require("./login/login"));
    processInclude(require("./components/passwordVisibilityToggle"));
});
